import { render } from "./SearchOrders.vue?vue&type=template&id=747c3750"
import script from "./SearchOrders.vue?vue&type=script&lang=js"
export * from "./SearchOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__